import React from 'react';


const Footer = () =>
    <footer className="footer">
      <div className="container">

        {/*
			<Link to="/test">Test</Link>
	        <Link to="/about">About</Link>
	        <Link to="/projects">Projects</Link>
	        <Link to="/projects/new">Projects new</Link>
        */}

      </div>
    </footer>;

export default Footer;
